import { render, staticRenderFns } from "./PreRegister.vue?vue&type=template&id=204de89c"
import script from "./PreRegister.vue?vue&type=script&lang=js"
export * from "./PreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports